import * as yup from 'yup'

import { trimmedInputValues, capitalizeWordsInValue, EMAIL_REGEX_FORMAT } from '../utils';

const capitalizeProcmartBranchName = (value) => {
    let words = []
    if(value){
        words = value.split(' ')
    }

    let capitalizedWords = []
    words.forEach(word => {
        if (word) {
            capitalizedWords.push(word[0].toUpperCase() + word.slice(1, word.length))
        }
    })
    
    return capitalizedWords.join(' ')
}

const CompanyBranchValidationSchema = yup.object().shape({
    branchName: yup.string().when(["companyId", "pmCompanyId"], {
        is: (companyId, pmCompanyId) => parseInt(companyId) === parseInt(pmCompanyId),
        then: () => yup.string()
                        .transform((value) => capitalizeProcmartBranchName(value))
                        .required('Please enter branch name')
                        .transform((value) => trimmedInputValues(value)),
        otherwise: () => yup.string()
                            .transform((value) => capitalizeWordsInValue(value))
                            .required('Please enter branch name')
                            .transform((value) => trimmedInputValues(value)),
    }),
    branchType: yup.string()
        .required('Please select branch type')
        .transform((value) => trimmedInputValues(value)),
    buyerSeller: yup.number().required('Please select branch buyer/seller'),
    clientSuccessManagerId: yup.object().when("isInternational", {
        is: true,
        then: () => yup.object().transform((value) => null).nullable(),
        otherwise: () => yup.object().when("companyBuyerSeller", {
          is: 2,
          then: () => yup.object().transform((value) => null).nullable(),
          otherwise: () => yup.object().required("Please select client success manager"),
        }),
    }),      
    //branchGSTINs: yup.array().required('Please select gstin'),
    vmiEnabled: yup.boolean()
        .transform(value => value === "Yes" ? true : false),

    /*userRoles: yup.array().of(
        yup.object().shape({
            companyRoleId: yup.number().required('Please select role'),
            //managerId: yup.number().required('Please select manager'),
        })
    ),*/
})

const AddCompanyBranchUsersValidationSchema = yup.array().of(
    yup.object().shape({
        firstName: yup.string()
            .transform((value) => capitalizeWordsInValue(value))
            .required('Please enter first name')
            .transform((value) => trimmedInputValues(value)),
            // .transform((value) => trimmedInputValues(value))
            // .required('Please enter first name'),
        lastName: yup.string()
            .transform((value) => capitalizeWordsInValue(value))
            .required('Please enter last name')
            .transform((value) => trimmedInputValues(value)),
            // .transform((value) => trimmedInputValues(value))
            // .required('Please enter last name'),
        ISDCode: yup.string()
            .transform((value) => trimmedInputValues(value))
            .required('Please select ISD Code'),
        phoneNumber: yup.string()
            .transform((value) => trimmedInputValues(value))
            .test('len', function(value) {
                const pmCompanyConfig = this.options.context
      
                const phoneNumberLength = pmCompanyConfig.phoneNumberLength
                const pinCodeErrorMessage = `Please enter valid phone number`
      
                if (value && !phoneNumberLength.includes(value.length)) {
                  return this.createError({ message: pinCodeErrorMessage })
                }
                return true
            })
            .required('Please enter user phone no'),
        emailId: yup.string()
            .transform((value) => trimmedInputValues(value))
            .lowercase()
            .matches(EMAIL_REGEX_FORMAT, 'Please enter valid email')
            .required('Please enter user email'),
    })
)




export { CompanyBranchValidationSchema, AddCompanyBranchUsersValidationSchema };